import { AssignmentReportFiltersState, AssignmentReportFiltersActionTypes, READ_ASSIGNMENT_REPORT_FILTERS_REQUEST, READ_ASSIGNMENT_REPORT_FILTERS_SUCCESS, READ_ASSIGNMENT_REPORT_FILTERS_FAILURE } from "store/reducers/types/assignmentReport/assignmentReportFilters";

const defaultState: AssignmentReportFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function assignmentReportFilters(state = defaultState, action: AssignmentReportFiltersActionTypes): AssignmentReportFiltersState {
  switch (action.type) {
    case READ_ASSIGNMENT_REPORT_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_ASSIGNMENT_REPORT_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_ASSIGNMENT_REPORT_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};